export class QueryParameterModel {
  static readonly KEY: string = 'queryParameterKey';

  url: string;
  keys: string[];
}
